'use client';

import {useEffect} from 'react';
import {logWarning} from '@/lib/logging';

/**
 * WakeupCall component
 *
 * Performs HTTP GET requests to external services when the page first loads to "wake up" those idle services.
 * Status codes from the endpoints are ignored.
 */
export function WakeupCall() {
  useEffect(() => {
    const performWakeupCalls = async () => {
      const endpoints = [
        '/transformation/version.json',
        '/api/version.json',
      ];

      // Fire all requests in parallel and ignore results
      for (const endpoint of endpoints) {
        fetch(endpoint)
          .catch(error => {
            // warn, but ignore errors
            logWarning({
              message: "Wakeup call failed",
              endpoint,
              error: error instanceof Error ? error.message : String(error)
            });
          });
      }
    };

    performWakeupCalls();
  }, []); // Empty dependency array ensures this only runs once on mount

  // This component doesn't render anything
  return null;
}
